















import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    value: {
      type: Number,
      default: undefined,
    },
  },
  setup(props) {
    const rating = computed(() => {
      return Number(((props.value * 5) / 100).toFixed(0));
    });

    return {
      rating,
    };
  },
});
